import React from 'react'
import BookButton from '../../Shared/BookButton';
import Image1 from '../../../img/Image1.png'
import Image2 from '../../../img/Image2.png'
import Image3 from '../../../img/Image3.png'
import Image4 from '../../../img/Image4.png'
import Image5 from '../../../img/Image5.png'
import Image6 from '../../../img/Image6.png'

export default function Abhay() {
    return (
        <div className='p-20' >
            <div className='p-8 text-center' >
                <h1 className='text-2xl mb-2 md:text-4xl font-bold '>
                    How <span className='text-blue-500'>ABHAY Program</span> Helps You
                </h1>
                <h2 className='text-lg md:text-lg font-semibold '>ABHAY Program is designed to help you in numerous Ways</h2>
            </div>
            <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6'>
                <Ways
                    image={Image1}
                    content='Provides Ability to learn,
                        find opportunitiies'
                />
                <Ways
                    image={Image2}
                    content="Build important focus techniques
                        and memory retention ability"
                />
                <Ways
                    image={Image3}
                    content="Honest Career Guidance
                        and Career Plan"
                />
                <Ways
                    image={Image4}
                    content="Complete Assistance and Analysis"
                />
                <Ways
                    image={Image5}
                    content="Explore the path of your
                        future goals "
                />
                <Ways
                    image={Image6}
                    content="Join the network of exclusive mentors
                        and top colleges students"
                />
            </div>
            <div className='flex justify-center'>
                <BookButton name="Experience a Session Now" />
            </div>

        </div>
    )

}


function Ways(props) {
    return (

        <div className="card bg-base-100 shadow-xl m-3">
            <figure className="px-10 py-10">
                <img src={props.image} alt="Shoes" className="rounded-xl" />
            </figure>
            <div className="card-body items-center text-center">
                <p>{props.content}</p>
            </div>
        </div>
    )

}